module.exports = __webpack_public_path__ + "img/lu.c6c7468b.svg";